'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module3Res2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3Res2, _Component);

  function Module3Res2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3Res2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3Res2.__proto__ || (0, _getPrototypeOf2.default)(Module3Res2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      module: 'Module 3',
      title: 'No vegies, please! Managing mealtime behaviour'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module3Res2, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                this.state.module
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Helpful strategies to encourage your child to eat:'
            ),
            _react2.default.createElement(
              'h4',
              null,
              '1. Use verbal praise'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Eg. "What a good boy for sitting at the table"'
            ),
            _react2.default.createElement(
              'h4',
              null,
              '2. Be encouraging and enthusiastic: '
            ),
            _react2.default.createElement(
              'p',
              null,
              'Eg. "Yum, this corn is really juicy!"'
            ),
            _react2.default.createElement(
              'h4',
              null,
              '3. Offer a variety of foods and introduce new foods regularly'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Many kids, especially those under 5 years, don\'t have stable taste preferences. Don\'t avoid providing foods that are new or you suspect they won\'t enjoy'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Stress at mealtimes causes an increase in the stress hormone, cortisol, which can decrease the appetites of both your child, and you! Serving familiar foods with unfamiliar foods can help to reduce stress at mealtimes'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Don\'t feel restricted by meal \'expectations\' - offer \'lunch\' foods at breakfast, for example, if it works for your family and encourages your child to view meals positively'
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              '4. Make mealtimes relaxed and stress-free'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Eg. Use them as a time to talk about everyone\'s day. It helps to',
              _react2.default.createElement(
                'strong',
                { className: styles.orangeText },
                ' plan to serve a fruit or vegetable at every meal and snack, '
              ),
              'so even if kids reject the vegetables provided at dinner, you know thy have had some during the day, which puts a lot less pressure on everybody at dinner time'
            ),
            _react2.default.createElement(
              'h4',
              null,
              '5. Be a positive role model'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Preschool aged children are often scared of trying new foods. They learn what is safe and good to eat by watching trusted adults, so make sure your child regularly sees you eating healthy foods.'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Children ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'require support from all caregivers, '
                  ),
                  'including grandparents and extended family, who can reinforce meal time rules and expectations.'
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              '6. Mix-in vegetables with meals'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'When you mix in vegetables also provide a sample of the vegetable on your child\'s plate, so they become familiar with it. Try mixing vegies into mince, pasta dishes, and quiche'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Whilst it is OK to "hide" vegetables if your child will not otherwise eat them, this doesn\'t teach children how to eat vegetables outside of them being mixed in a dish. It is best to ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'try and serve vegetables whole '
                  ),
                  'when possible, but also "hide" vegetables if you need to'
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              '7. Make food interesting and fun'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Experiment with ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'different ways of cooking'
                  ),
                  ' and',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    ' presenting foods'
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Encourage kids to be involved in ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'shopping, preparing and cooking food '
                  ),
                  'where able.'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Don\'t feel like you can only boil, steam or bake vegetables. Use ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'herbs and spices '
                  ),
                  'to "jazz" up vegetables, saute in olive oil and garlic, or top with cheese. Offering variety and using these strategies can show kids that vegetables can be exciting to eat'
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              '8. Teach your child to listen to their tummy'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Chlildren are quite good at ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'self-regulating'
                  ),
                  ' their food intake'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'Acknowledge your child\'s internal hunger cues'
                  ),
                  ', Eg. Acknowledge that they are feeling hungry and inform them of when the next meal or snack will be'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Every now and then, allow your child to ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'serve themselves'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              '9. Regularly give your child some (discrete) choices about the meal'
            ),
            _react2.default.createElement(
              'p',
              null,
              '"Would you like peas or broccoli tonight?" ',
              _react2.default.createElement(
                'strong',
                null,
                'not'
              ),
              ' "What do you want for dinner tonight?"'
            ),
            _react2.default.createElement(
              'h4',
              null,
              '10. Ask kids to describe'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Ask kids to describe what they see, taste and experience when eating (especially new foods) in terms of temperature, taste, texture, and smell. Eg. Is the food sweet, spicy, or salty? Creamy, crackly or crunchy?'
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module3Res2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module3Res2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/3/Res2.js
// module id = 1248
// module chunks = 0